import React from "react"
import BenefitsCard from "./BenefitsCard"
import { BenefitsSectionProps } from "@/app/interface/components"
import styles from "@/styles/BenefitsSection.module.scss"
import FreemodeSlide from "../UI/FreemodeSlide"
import MediaQuery from "react-responsive"

const BenefitsSection: React.FC<BenefitsSectionProps> = ({ width, isDesktop=false }) => {
    const isTablet = MediaQuery({ minWidth: 540 })
    const media = isDesktop ? "desktop" : isTablet ? "tablet" : "mobile"

    return (
        <section className={styles.main}>
            <h2 className="h2-medium">Vantagens do consórcio azul agro</h2>
            <FreemodeSlide gap={isDesktop ? "24px" : "8px"}>
                <BenefitsCard img={`https://gabcomercio.azureedge.net/azul-agro/${media}/consorcio/benefits/img1.webp`} number={1} text={"SEM JUROS"} width={width} />
                <BenefitsCard img={`https://gabcomercio.azureedge.net/azul-agro/${media}/consorcio/benefits/img2.webp`} number={2} text={"ASSEMBLEIAS MENSAIS TRANSMITIDAS PELA INTERNET"} width={width} />
                <BenefitsCard img={`https://gabcomercio.azureedge.net/azul-agro/${media}/consorcio/benefits/img3.webp`} number={3} text={"SEM TAXA DE ADESÃO E EXPEDIENTE"} width={width} />
                <BenefitsCard img={`https://gabcomercio.azureedge.net/azul-agro/${media}/consorcio/benefits/img4.webp`} number={4} text={"SEM HIPOTECA"} width={width} />
                <BenefitsCard img={`https://gabcomercio.azureedge.net/azul-agro/${media}/consorcio/benefits/img5.webp`} number={5} text={"SEM SEGURO PRESTAMISTA"} width={width} />
            </FreemodeSlide>
        </section>
    )
}

export default React.memo(BenefitsSection)
